import Vue from 'vue'
import VueRouter from 'vue-router'
import AdminView from '../views/AdminView'
import UserView from '../views/UserView'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: UserView,
  },
  {
    path: '/admin',
    name: 'manage',
    component: AdminView,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
